import { SvgIcon } from '@mui/material'

// Types
import type { SvgIconProps } from '@mui/material'

const NorthWestArrowIconAtom = (props: SvgIconProps) => (
	<SvgIcon {...props} viewBox="-5 -5 20 20">
		<path stroke="currentColor" strokeWidth={1.26239} d="M8.23047 8.11691L1.09794 0.984375M1.09794 0.984375H8.23047M1.09794 0.984375V8.11691" />
	</SvgIcon>
)

export default NorthWestArrowIconAtom
